export const translate = (key) => window.__litium.translation[key] || key;

/**
 * Website texts are maintained in Backoffice and translate() hands back the key itself when a text
 * is missing. For texts added together with a new feature the design label is a better fallback
 * than a key on the site.
 */
export const translateOr = (key, fallback) => {
  const value = translate(key);

  return value === key ? fallback : value;
};
